import { IChambre } from '@app/shared';
import { find, first, forOwn, filter } from 'lodash';
import { AvailRoom } from './availibility.model';
import { Line } from './line.model';
import { isDefined } from '../translator/util';
import { ICombineEngine } from '@app/shared';
export class Room {
    id: number;
    name: string;
    surface: number;
    isSmoker: boolean;
    isBookingBasic: boolean;
    maxoccup: string;
    listBed: any;
    images: string[];
    description: string;
    services: any;
    baby: number = 3;
    child: number = 6;
    cot: boolean = true;
    taxe: any;
    stock: number;
    caracteristique: {};
    orderAdults: number;// TODO: remove field sort
    orderEnfants: number;// TODO: remove field sort
    orderTtc: number;// TODO: remove field sort
    isDeleted: boolean;
    roomUpgrade: number = 0;

    lines: Array<Line> = [];
    constructor(chambre: IChambre) {
        this.id = chambre.id;
        this.surface = chambre.surface;
        this.isSmoker = !!chambre.isFumeur;
        this.maxoccup = chambre.maxoccup;
        this.isDeleted = chambre.isDeleted;
        forOwn(chambre.lit, function (value, key) {
            value.map(o => {
                o.value.map(i => {
                    if (i.id != undefined) {
                        i.id = i.id.toLowerCase().replace(' ', '');
                        return i;
                    }
                })
                return o;
            })
            chambre.lit[key] = value;
        });
        this.listBed = chambre.lit;
        this.images = chambre.img;
        this.isBookingBasic = !!chambre.isBookingBasic;
        this.caracteristique = chambre.groupcarac;
    };

    /**
     * add line
     * @returns Room
     */
    addLine(line: Line) {
        this.lines.push(line);
        return this;
    }

    /**
     * creer les lines pour cette chambre
     * @returns Room
     */
    public bindingData(availRoom: AvailRoom) {
        if (isDefined(availRoom)) {
            this.stock = availRoom.stock;
            this.taxe = availRoom.taxe;
            for (let l of availRoom.lines) {
                let newL = new Line();
                newL.bindingData(l);
                this.addLine(newL);
            }
        }
        return this;
    }

    /**
    * find line by id and occupation
    * @param intger id line
    * @param string occupation occupation
    * @returns AvailLine|undefined
    */
    public findLineBy(id: number, occupation: string): Line {
        return find(this.lines, { id: parseInt(id.toString()), occupation: occupation })
    }

    /**
    * find line by id and indexSearch
    * @param intger id line
    * @param string indexSearch index search 
    * @returns AvailLine|undefined
    */
    public findLineByIndex(id: number, indexSearch: string): Line {
        return find(this.lines, { id: parseInt(id.toString()), indexSearch: indexSearch })
    }
    public findLineWithEngine(id: number, indexSearch: string): Line {
        return find(this.lines, (l: Line) => { return l.id == parseInt(id.toString()) && l.engines.filter((c: ICombineEngine) => c.combine.indexSearch == indexSearch).length > 0 })
    }

    /**
    * find line by id
    * @param intger id line
    * @returns AvailLine|undefined
    */
    public findLine(id: number): Line {
        return find(this.lines, { id: parseInt(id.toString()) })
    }

    /**
     * tilte room  ex: {{ room.getTitle() | translate}}
     * @returns string
     */
    getTitle(): string {
        return 'chamber.' + this.id + '-titer';
    }

    /**
     * description room  ex: {{ room.getDescription() | translate}}
     * @returns string
     */
    getDescription(): string {
        return 'chamber.' + this.id + '-description';
    }

    /**
     * tilte Caracteristique  ex: {{ room.getTitleCaracteristique(90) | translate}}
     * @returns string
     */
    getTitleCaracteristique(id: string): string {
        return 'chambercaracteristique.' + id + '-titer';
    }

    /**
     * image room
     * @returns string
     */
    getFirstImage(): string {
        if (this.images.length > 0)
            return first(this.images);
        return ''
    }

    /**
     * has image
     * @returns boolean
     */
    hasImage(): boolean {
        return !!this.images;
    }

    /**
     * nb line dispo
     * @returns number 
     */
    getNbLineDispo(): number {
        return filter(this.lines, { isDispo: true }).length;
    }

    /**
     * is room has combine upgrade
     * @returns boolean
     */
    isUpgraded(): boolean {
        return !!this.lines.filter(l => l.engines.filter((c: ICombineEngine) => !!c.combine.room_upgrade).length > 0).length
    }

    getRoomUpgradeTo(): number {
        if (this.isUpgraded()) {
            const line = this.lines.find(l => l.engines.filter((c: ICombineEngine) => !!c.combine.room_upgrade).length > 0);
            const [idRoom] = line.engineSelected.combine.room_upgrade_to.split('_');
            return parseInt(idRoom);
        }
        return 0;
    }

    toJson(): any {
        return {
            id: this.id,
            name: this.name,
            surface: this.surface,
            isSmoker: this.isSmoker,
            isBookingBasic: this.isBookingBasic,
            listBed: this.listBed,
            images: this.images,
            description: this.description,
            services: this.services,
            baby: this.baby,
            child: this.child,
            cot: this.cot,
            taxe: this.taxe,
            stock: this.stock,
        };
    }
}
